import axios from "axios";
import loginService from "./services/LoginService";
import tableauService from "./services/TableauService";

const BASE_URL = process.env.VUE_APP_BASE_URL + process.env.VUE_APP_API_PATH;
const httpClient = axios.create({
  baseURL: BASE_URL,
  headers: {
    "Content-type": "application/json",
    "Accept": "application/json"
  }
});

const LOGIN_URL = '/login/auth';
const ACCESS_KEY_URL = '/login/access';
const ACCESS_KEY_URL_TABLEAU = 'tableau/access'
const TOKEN_REFRESH_URL = '/login/refresh';
const TOKEN_REFRESH_URL_TABLEAU = '/tableau/refresh';
const PUBLIC_URLS = [LOGIN_URL,ACCESS_KEY_URL, ACCESS_KEY_URL_TABLEAU];
const TABLEAU_URL = '/tableau';
const RESULTATS_ACUMULATS = '/resultats/acumulats';

//Intercepta cada peticio request que faci el front
httpClient.interceptors.request.use(
  (config) => {
    //console.log(config);
    //Si la url del request no es publica i no comença per tableau, llavors ha d'agafar el token que correspon al login per user-pass
    if (!PUBLIC_URLS.includes(config.url) && !config.url.startsWith(TABLEAU_URL)){
      let token = loginService.getAccessToken();
      if(TOKEN_REFRESH_URL === config.url){
        token = loginService.getRefreshToken();
      }

      if (token) {
        config.headers['Authorization'] = `Bearer ${ token }`
      }

    }
    //Si la url del request es tableau o la dels acumulats, comprova si s'ha fet login anteriorment amb user-pass.
    if(config.url.includes(TABLEAU_URL) || config.url.includes(RESULTATS_ACUMULATS)){
      //Si ha fet login amb user-pass, llavors ha d'agafar el token de la sessio iniciada amb user-pass
      if(loginService.isLoggedIn()){
          let token = loginService.getAccessToken();
        if(TOKEN_REFRESH_URL === config.url){
          token = loginService.getRefreshToken();
        }

        if (token) {
          config.headers['Authorization'] = `Bearer ${ token }`
        }
      //Si no ha fet login vol dir que esta accedint amb access_key i s'ha d'agafar el token corresponent al "tableau"
      } else{
        let token = tableauService.getTableauAccessoken();
      
        if(TOKEN_REFRESH_URL_TABLEAU === config.url){
          token = tableauService.getTableauRefreshToken();
        }

        if(token){
          config.headers['Authorization'] = `Bearer ${ token }`
        }
      }
      
    }

    return config
  },

  (error) => {
    return Promise.reject(error)
  }
)

//Intercepta cada response de peticions que fa el front
httpClient.interceptors.response.use(function (response) {
  //console.log(response);
  //Si la url del response correspon al login, al token refresh o al access_key que no sigui tableau llavors seteja la informacio del token d'usuari
  if(LOGIN_URL === response.config.url || TOKEN_REFRESH_URL === response.config.url || response.config.url.includes(ACCESS_KEY_URL)){
    console.log("loginService - setUserInfo()");
    loginService.setUserInfo(response.data);
  }
  //Si la url del response correspon al "tableau" o al token refresh de "tableau" o al access_key de "tableau", seteja la info del token de "tableau"
  if(TOKEN_REFRESH_URL_TABLEAU === response.config.url || TOKEN_REFRESH_URL_TABLEAU === response.config.url || response.config.url.includes(ACCESS_KEY_URL_TABLEAU)){
    console.log("tableauService - setTableauInfo()");
    tableauService.setTableauInfo(response.data);
  }

  return response;
}, function (error) {
  //Si el response ha donat error, gestiona aquests errors de diferentes formes
  //console.log(error);
  //Si la url correspon al login/refresh o ha donat un error 401 o 403, llavors tanca la sessio d'usuari
  if ((401 === error.response.status || 403 === error.response.status) && error.config.url === TOKEN_REFRESH_URL) {       
    loginService.logout();    
    return Promise.reject(error);
  }
  //Si la url correspon al tableau/refresh o ha donat un error 401 o 403, llavors tanca la sessio de "tableau"
  if ((401 === error.response.status || 403 === error.response.status) && error.config.url === TOKEN_REFRESH_URL_TABLEAU) {       
    tableauService.logout();    
    return Promise.reject(error);
  }
  //Si la url no comença per tableau, no es una url considerada publica i dona un error 401, llavors intentem renovar el token
  if (401 === error.response.status && !PUBLIC_URLS.includes(error.config.url) && !error.config.url.startsWith(TABLEAU_URL) ) {
    //Si obtenim error de token no vàlid, intentem renovar    
      return httpClient.post(TOKEN_REFRESH_URL,{})
          .then(res => {
              if (res.status === 200) {
                  error.config.headers['Authorization'] = 'Bearer ' + loginService.getAccessToken();
                  return axios(error.config);
              }
          })
  }
  //Si la url comença per tableau i dona un error 401, llavors intentem renovar el token
  if (401 === error.response.status && error.config.url.startsWith(TABLEAU_URL)){
    return httpClient.post(TOKEN_REFRESH_URL_TABLEAU,{})
    .then(res => {
        if (res.status === 200) {
            error.config.headers['Authorization'] = 'Bearer ' + tableauService.getTableauAccessoken();
            return axios(error.config);
        }
    })
  }
      return Promise.reject(error);
  
});


export default httpClient;